import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/page-header';
import { Badge } from '@/components/ui/badge';

export const Route = createFileRoute('/help/shortcuts')({ component: Shortcuts });

/** The QBO keyboard set (document 05). Shortcuts for screens not built yet are marked. */
const SHORTCUTS: Array<[string, string, boolean]> = [
  ['Ctrl+Alt+A', 'Chart of accounts', true],
  ['Ctrl+Alt+F', 'Search', true],
  ['/', 'Search (when not typing in a field)', true],
  ['Ctrl+Alt+/', 'Show shortcuts', true],
  ['Ctrl+Alt+S', 'Save and close (in a form)', true],
  ['Ctrl+Alt+D', 'Save and new (in a form)', true],
  ['Ctrl+Alt+X', 'Exit the form (inside a form)', true],
  ['Ctrl+Alt+I', 'New invoice', true],
  ['Ctrl+Alt+E', 'New quote', true],
  ['Ctrl+Alt+R', 'Receive payment', true],
  ['Ctrl+Alt+W', 'Vendor payment', false],
  ['Ctrl+Alt+C', 'Customers list', true],
  ['Ctrl+Alt+V', 'Vendors list', true],
  ['Ctrl+Alt+L', 'Lists (settings gear)', false],
  ['Ctrl+Alt+H', 'Help', false],
  ['Ctrl+Alt+M', 'Send, or approve and send (in a form)', true],
];

const DATE_KEYS: Array<[string, string]> = [
  ['T', 'Today'],
  ['+ / -', 'Next / previous day'],
  ['W / K', 'First / last day of the week'],
  ['M / H', 'First / last day of the month'],
  ['Y / R', 'First / last day of the year'],
];

function Shortcuts() {
  return (
    <>
      <PageHeader title="Keyboard shortcuts" description="On macOS use Control+Option." />
      <div className="grid gap-4 lg:grid-cols-2">
        <section className="rounded-lg border bg-card p-4">
          <h2 className="mb-2 font-semibold">Anywhere</h2>
          <table className="w-full text-sm">
            <tbody>
              {SHORTCUTS.map(([keys, action, ready]) => (
                <tr key={keys} className="border-b last:border-0">
                  <td className="w-[140px] py-1.5">
                    <kbd className="rounded border bg-muted px-1.5 py-0.5 text-xs">{keys}</kbd>
                  </td>
                  <td className="py-1.5">{action}</td>
                  <td className="py-1.5 text-right">
                    {ready ? null : <Badge variant="outline">Coming soon</Badge>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
        <section className="rounded-lg border bg-card p-4">
          <h2 className="mb-2 font-semibold">Date fields</h2>
          <table className="w-full text-sm">
            <tbody>
              {DATE_KEYS.map(([keys, action]) => (
                <tr key={keys} className="border-b last:border-0">
                  <td className="w-[140px] py-1.5">
                    <kbd className="rounded border bg-muted px-1.5 py-0.5 text-xs">{keys}</kbd>
                  </td>
                  <td className="py-1.5">{action}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <h2 className="mt-4 mb-2 font-semibold">Amount fields</h2>
          <p className="text-sm text-muted-foreground">
            Type arithmetic such as <code>1200*1.05</code> or <code>(450+380)/2</code>; it is worked
            out when you leave the field or press <kbd>=</kbd>.
          </p>
        </section>
      </div>
    </>
  );
}
